import { render, staticRenderFns } from "./BloodMarkersTable.vue?vue&type=template&id=32269dfa&scoped=true"
import script from "./BloodMarkersTable.vue?vue&type=script&lang=js"
export * from "./BloodMarkersTable.vue?vue&type=script&lang=js"
import style0 from "./BloodMarkersTable.vue?vue&type=style&index=0&id=32269dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32269dfa",
  null
  
)

export default component.exports